import { render } from "./JarvisSection.vue?vue&type=template&id=190d83f9&scoped=true"
import script from "./JarvisSection.vue?vue&type=script&lang=js"
export * from "./JarvisSection.vue?vue&type=script&lang=js"

import "./JarvisSection.vue?vue&type=style&index=0&id=190d83f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190d83f9"]])

export default __exports__